import { Typography } from 'antd';
import React from 'react'
import { RefLanguage } from '../hooks/LanguageHooks';
import { SettingOutlined } from '@ant-design/icons';

const { Title } = Typography;


function ServerDown() {


    const i18n = RefLanguage()

    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.9)', // semi-transparent white
                zIndex: 10,
                pointerEvents: 'auto', // allow events on this overlay
                // paddingLeft: "10vh"
            }}

        >
            <div style={{ padding: '10vh', paddingTop: "20vh", textAlign: 'center', backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
                <Typography >
                    <Title level={2}>{i18n.t("serverDown")}</Title>
                </Typography>

                <SettingOutlined style={{ fontSize: '40px', color: 'var(--primary-color-1)' }} />
                <Typography >
                    <Title level={4}>{i18n.t("tryAgainLater")}</Title>
                </Typography>

            </div>
        </div>
    )
}

export default ServerDown
